import { ArquivoDTO } from '../../models/arquivo/arquivoDTO';
import { API_CONFIG } from './../../config/api.config';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Injectable } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { InscricaoDTO } from 'src/app/models/agendamento/inscricaoDTO';
import { Page } from 'src/app/models/page.model';
import { ConfiguracaoUploadDTO } from 'src/app/models/arquivo/configuracaoUploadDTO';



@Injectable({
  providedIn: 'root'
})
export class ArquivoService {

  private uploadedImage!: string;

  
  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) { }

  findById(id: number) : Observable<ArquivoDTO> {

    return this.http.get<ArquivoDTO>( API_CONFIG.apiURL+'/arquivosfisicos/' + id);

  }

  

  findByPath(entidade: string, idEntidade: number, diretorio: string) : Observable<ArquivoDTO[]> {

    return this.http.get<ArquivoDTO[]>( API_CONFIG.apiURL+'/arquivosfisicos/findByPath?entidade=' + entidade + '&idEntidade=' + idEntidade + '&diretorio=' + diretorio);

  }

  findPageByPath(
    entidade: string,
    idEntidade: number,
    diretorio: string,
    filtro: string,
    page: number,
    size: number,
    sortBy: string,
    sort: string
  ): Observable<Page<ArquivoDTO>> {

    const params = new URLSearchParams();

    params.set('entidade', entidade);
    params.set('idEntidade', idEntidade.toString());
    params.set('diretorio', diretorio);
    params.set('filtro', filtro ?? '');
    params.set('page', page.toString());
    params.set('size', size.toString());
    params.set('sortBy', sortBy);
    params.set('sort', sort);

    return this.http.get<Page<ArquivoDTO>>(
      `${API_CONFIG.apiURL}/arquivosfisicos/findPageByPath?${params.toString()}`
    );
  }

  downloadBlob(path: string, nome: string): Observable<Blob> {

    const filePublicURL = this.getFilePublicURL(path,nome);

    const url = `${API_CONFIG.apiURL}/arquivosfisicos/downloadBlob?filePath=${encodeURIComponent(filePublicURL)}`;
    
    return this.http.get(url, { responseType: 'blob' }); // Define o responseType como 'blob'
  }


  findEditalByCurso(idCurso: number) : Observable<ArquivoDTO[]> {

    return this.http.get<ArquivoDTO[]>( API_CONFIG.apiURL+'/arquivosfisicos/findEditalByCurso?idCurso=' + idCurso );

  }

  delete(id: number) : Observable<void> {

    return this.http.delete<void>( `${API_CONFIG.apiURL}${'/arquivosfisicos/'}${id}`);

  }

  deleteFromFileSystem(entidade: string, diretorio: string, idEntidade: number, fileName: string) : Observable<void> {

    return this.http.delete<void>( `${API_CONFIG.apiURL}${'/arquivosfisicos/deleteFromFileSystem/'}${entidade}${'/'}${diretorio}${'/'}${idEntidade}${'/'}${fileName}`);

  }

  deleteByPath(diretorio: string, fileName: string): Observable<void> {
    const encodedDiretorio = encodeURIComponent(diretorio);
    const encodedFileName = encodeURIComponent(fileName);
    
    return this.http.delete<void>(`${API_CONFIG.apiURL}/arquivosfisicos/delete/byPath?path=${encodedDiretorio}&fileName=${encodedFileName}`);
  }


  update(arquivoDTO: ArquivoDTO) : Observable<any> {
    
    return this.http.put<any>( API_CONFIG.apiURL+'/arquivosfisicos/update/' + arquivoDTO.id
                             , arquivoDTO
                             , { observe: 'response' });

  }


  aprovar(arquivoDTO: ArquivoDTO, inscricao: InscricaoDTO): Observable<any> {
    const payload = {
      arquivo: arquivoDTO,
      inscricao: inscricao
    };
  
    return this.http.put<any>(
      API_CONFIG.apiURL + '/arquivosfisicos/aprovar/' + arquivoDTO.id,
      payload,
      { observe: 'response' }
    );
  }
  


  reprovar(arquivoDTO: ArquivoDTO, inscricao: InscricaoDTO): Observable<any> {
    const payload = {
      arquivo: arquivoDTO,
      inscricao: inscricao
    };
  
    return this.http.put<any>(
      API_CONFIG.apiURL + '/arquivosfisicos/reprovar/' + arquivoDTO.id,
      payload,
      { observe: 'response' }
    );
  }
  

  upload( arquivo: File
        , nomeEntidadeAssociada:string
        , idEntidadeAssociada: number | null
        , nomeDiretorioDestino: string
        , tipoArquivo: string
        , nomeArquivo: string = ""
        , validarConteudoArquivoComIA: boolean  = false
        , ordemExibicaoArquivo?: number ): Observable<any>{

    const formData = new FormData();
    formData.append('arquivo', arquivo);
    formData.append('nomeEntidadeAssociada', nomeEntidadeAssociada);
    
    if(idEntidadeAssociada){
      formData.append('idEntidadeAssociada', idEntidadeAssociada?.toString());
    }
    formData.append('nomeDiretorioDestino', nomeDiretorioDestino);
    formData.append('tipoArquivo', tipoArquivo);
    formData.append('nomeArquivo', nomeArquivo);
    formData.append('validarConteudoArquivoComIA', validarConteudoArquivoComIA.toString());
    
    if (ordemExibicaoArquivo !== undefined && ordemExibicaoArquivo !== null) {
      formData.append('ordemExibicaoArquivo', ordemExibicaoArquivo.toString());
    }

    return this.http.post<any>( API_CONFIG.apiURL+'/arquivosfisicos/upload'
                              , formData
                              , { observe: 'response' }); //.pipe(timeout(100000))
   
  }


  copyAndPaste( pathOrigem:string
              , nomeArquivoOrigem: string
              , nomeEntidadeDestino: string
              , idEntidadeDestino: number
              , tipoArquivo: string
              , nomeDiretorioDestino: string 
              , nomeArquivoDestino: string ): Observable<any>{

      
      //para usar formData é necessário remover o content-type = application:json do header no httpconfig.interceptor.ts     
      let formData = new FormData();
      formData.append('pathOrigem', pathOrigem);
      formData.append('nomeArquivoOrigem', nomeArquivoOrigem);
      formData.append('nomeEntidadeDestino', nomeEntidadeDestino);
      formData.append('idEntidadeDestino', idEntidadeDestino.toString());
      formData.append('nomeDiretorioDestino', nomeDiretorioDestino);
      formData.append('tipoArquivo', tipoArquivo);
      formData.append('nomeArquivoDestino', nomeArquivoDestino);

      return this.http.post<any>( API_CONFIG.apiURL+'/arquivosfisicos/copyAndPaste?'
                                , formData
                                , { observe: 'response' }); //.pipe(timeout(100000))

}


  insert(arquivoDTO: ArquivoDTO) : Observable<any> {
    
    return this.http.post<any>( API_CONFIG.apiURL+'/arquivosfisicos'
                              , arquivoDTO
                              , { observe: 'response' }); //.pipe(timeout(100000))

  }

  
  getFilePublicURL(fullPath: string, fileName: string): string{

    //trocar a parte do diretório raiz pela url do diretório virtual
    const pathVirtual = fullPath?.toLocaleLowerCase().replace( API_CONFIG.iisVirtualDirectoryPath.toLocaleLowerCase()
                                                             , API_CONFIG.iisVirtualDirectoryURL.toLocaleLowerCase());
                                                             
    if(fileName){
      return pathVirtual + "/" + fileName;
    }                                                         
    
    return pathVirtual;
  }


  

  convertToPDFA(pathOrigem: string, nomesArquivosOrigem: string[]): Observable<string[]>{

    return this.http.get<string[]>( API_CONFIG.apiURL+'/arquivosfisicos/convertToPDFA?pathOrigem=' + pathOrigem + '&nomesArquivosOrigem='+nomesArquivosOrigem);

  }


  getSafeViewerPath(arquivo: ArquivoDTO): SafeResourceUrl{

    if(
        arquivo.nome.toLowerCase().endsWith('xls') || 
        arquivo.nome.toLowerCase().endsWith('xlsx') ||
        arquivo.nome.toLowerCase().endsWith('doc') || 
        arquivo.nome.toLowerCase().endsWith('docx') ||
        arquivo.nome.toLowerCase().endsWith('ppt') || 
        arquivo.nome.toLowerCase().endsWith('pptx')
      ){
      
      const path = this.getFilePublicURL('https://view.officeapps.live.com/op/view.aspx?src=' + arquivo.path, arquivo.nome);
      //const path = 'https://docs.google.com/gview?url=' + this.getFilePublicURL(arquivo.path, arquivo.nome);
      
      return this.sanitizer.bypassSecurityTrustResourceUrl(path);
    
    }else{
      
      // Adiciona um parâmetro único para evitar cache
      const timestamp = new Date().getTime();
      const path = this.getFilePublicURL(arquivo.path, arquivo.nome) + '?nocache=' + timestamp;
      return this.sanitizer.bypassSecurityTrustResourceUrl(path);
    
    }
  }
  

  getBase64FromUrl(url: string): Promise<string> {
    return fetch(url)
      .then(res => res.blob())
      .then(blob => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      }));
  }

  getConfiguracaoUpload(): Observable<ConfiguracaoUploadDTO> {

    return this.http.get<ConfiguracaoUploadDTO>(
      API_CONFIG.apiURL + '/arquivosfisicos/configuracaoupload'
    );

  }
  
}
